import api from '@/apis/di/budgetItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance, computed } from 'vue';

import { useStore } from 'vuex';
import { ModuleBudgetItem } from '@/stores/moduleConst';
import { MSConstant } from '@/commons/wildcards/index.js';
// Combo grid Tiết tiểu Mục
export const useBudgetDetailItemComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBudgetDetailItemComboboxLoadData = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [
      {
        Field: 'budget_item_type',
        Value: proxy.$ms.constant.BudgetItemType.SubSection,
      },
      { Field: 'inactive', Value: false, Ors: ors },
    ];
    payload.sort = 'budget_item_code';
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const budgetDetailItemComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã tiết tiểu mục',
        dataField: 'budget_item_code',
        width: 130,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tiết tiểu mục',
        dataField: 'budget_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 470,
      },
    ],
    displayField: 'budget_item_code',
    valueField: 'budget_item_code',
    queryMode: 'local',
    dropdownWidth: 600,
    modelValueField: 'budget_detail_item_code',
    comboboxLoadData: onBudgetDetailItemComboboxLoadData,
  };
  const store = useStore();
  const budgetItems = store.getters[`${ModuleBudgetItem}/items`];

  const budgetItemCombo = computed(() => {
    return budgetItems.filter(x => !x.inactive && x.budget_item_type === MSConstant.BudgetItemType.SubSection);
  });
  comboboxDataRemote['budget_detail_item_code'] = budgetItemCombo;
  // Sự kiện load combo trên grid
  return {
    budgetDetailItemComboConfig,
    onBudgetDetailItemComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
